import { render } from "./Loading.vue?vue&type=template&id=65db63d6"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=65db63d6&lang=scss"
script.render = render

export default script